import type { TimePeriod } from '@carboncopyco/types';
import { ColorHex } from '@carboncopyco/ui';
import { integersFormatter } from '@carboncopyco/utils';
import { useState } from 'react';
import { OverviewTabChartCard } from '../../OverviewTabChartCard';
import { useActivityOverviewData } from '../../useActivityOverviewData';
import { useTourPageProps } from '../TourPageContext';

export const ActivityOverview = () => {
  const { organizationId, workspaceId, tourId } = useTourPageProps();
  const [timePeriod, setTimePeriod] = useState<TimePeriod>('30');
  const {
    chartData,
    nowData,
    isLoading,
    isLoadingPrevData,
    getPercentages,
    getDescription,
    isError,
  } = useActivityOverviewData({
    organizationId,
    workspaceId,
    timePeriod,
    assetId: String(tourId),
    resourceTypes: ['tour'],
  });

  const { values } = nowData?.results[0] ?? {};

  return (
    <OverviewTabChartCard
      subtitle="Visits"
      description={getDescription('occurrences')}
      kpiNumber={
        values?.occurrences ? integersFormatter(values.occurrences) : ''
      }
      kpiRawNumber={values?.occurrences}
      kpiPercentage={getPercentages('occurrences')}
      timePeriod={timePeriod}
      setTimePeriod={setTimePeriod}
      negative={Number(getPercentages('occurrences')) < 0}
      color={ColorHex.accent1200}
      isError={isError}
      isEmpty={!isLoading && !values?.occurrences}
      isLoading={isLoading || isLoadingPrevData}
      lineChartData={chartData}
      tooltipText="The number of times the tour was visited during the specified period"
      chartName="Visits"
    />
  );
};
